import script from "./UserDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailsPage.vue?vue&type=style&index=0&id=6ecf3e9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ecf3e9c"]])

export default __exports__